var LangUtils = {

    valueForLanguage: function(multiValue, lang) {
        if (!multiValue) {
            return null;
        }
        if (typeof(multiValue) === 'string') {
            return multiValue;
        }
        if (!lang) {
            lang = "en";
        }

        let value = multiValue[lang];
        if (!value) {
            value = multiValue['en'];
            if (!value) {
                for (const key of Object.keys(multiValue)) {
                    value = multiValue[key];
                    if (value) {
                        return value;
                    }
                }

                if (!value) {
                    return null;
                }
            }
        }

        return value;
    }
}

export default LangUtils;